import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import MovieCard from './MovieCard';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  linkTo?: string;
  linkLabel?: string;
}

export default function MovieGrid({ title, subtitle, movies, linkTo, linkLabel }: MovieGridProps) {
  return (
    <section className="py-8 md:py-12" aria-label={title}>
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              {title}
            </h2>
            {subtitle && (
              <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {linkTo && linkLabel && (
            <Link
              to={linkTo}
              className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap transition-colors"
            >
              {linkLabel}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}